//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiCell from "../../components/cell/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
import MulConfirm from "../../components/confirm/Mul";
import { clear } from "../../store";

export default {
  name: "MyPlanAddInstagramPage",
  components: { HiHeader, HiButton, HiCell, InstagramUserItem, MulConfirm },
  data() {
    const _this = this;
    return {
      showLoginMenu: false,
      buttons: [
        {
          text: this.$t("addInstagramPage.loginBtn"),
          async click() {
            // _this.$router.push({name: 'LoginInstagramPage'})
            return true;
          },
        },
        {
          text: this.$t("addedInstagramPage.mulMenuLogoutBtn"),
          async click() {
            clear();
            _this.$router.push({ name: "LoginApphiPage" });
            return true;
          },
        },
      ],
    };
  },
  methods: {
    /**
     * 删除选项
     * @param item 对应项
     */
    async remove(item) {
      await this.$confirm.show(this.$t("addInstagramPage.removeTitle"));
      try {
        this.$loading.show();
        await item.remove();
        this.$loading.hide();
        if (this.removeAbleNum === 0) {
          this.showLoginMenu = true;
        }
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    /**
     * add Instagram 点击事件
     */
    addInstagramClick() {
      // this.$router.push({name: 'LoginInstagramPage', query: {type: 'linked'}})
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      console.log(this.user.linkedInstagramList);
      // 根据类型进行分组
      let types = [];
      const limitedPublishers = this.user.linkedInstagramList.filter(
        (l) => !l.isUnlimited && !l.isMember
      );
      const unlimitedPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isUnlimited && !l.isMember
      );
      const memberPublishers = this.user.linkedInstagramList.filter(
        (l) => l.isMember
      );
      if (unlimitedPublishers.length > 0) {
        types.push({
          itemType: "remove",
          title: this.$t("addUnlimitedAccountPage.normalUnlimitedUserType"),
          items: unlimitedPublishers,
        });
      }
      if (memberPublishers.length > 0) {
        types.push({
          itemType: "member",
          title: this.$t("addUnlimitedAccountPage.memberUserType"),
          items: memberPublishers,
        });
      }
      if (limitedPublishers.length > 0) {
        types.push({
          itemType: "remove",
          title: this.$t("addUnlimitedAccountPage.freeUserType"),
          items: limitedPublishers,
        });
      }
      return types;
    },
    removeAbleNum() {
      return this.user.linkedInstagramList.filter((l) => !l.isMember).length;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/my_plan/AddInstagram.vue